import { OrderType } from '@modules/common/models/enums/OrderManagement'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { EnhancedViewIconMapping, View } from '@modules/order/constants/views'
import { KPITableView } from '@modules/order/stores/view/KPI/KPIViewTableService'
import { ListTableView } from '@modules/order/stores/view/List/ListViewTableService'
import { getEnumValue } from '@utils/get-enum-value'

export const getEnhancedViews = (clientType, orderType) => {
  if (clientType === getEnumValue(VIPClientType.Internal)) {
    return [
      {
        id: View.Product,
        name: {
          key: 'common.views.cardView',
          default: 'Card View'
        },
        icon: EnhancedViewIconMapping[View.Product]
      },
      {
        id: View.List,
        subSection: ListTableView.Summary,
        name: {
          key: 'common.views.listViewSummary',
          default: 'List View - Summary'
        },
        icon: EnhancedViewIconMapping[View.List]
      },
      {
        id: View.List,
        subSection: ListTableView.Quantity,
        name: {
          key: 'common.views.listViewQuantity',
          default: 'List View - Quantity'
        },
        icon: EnhancedViewIconMapping[View.List]
      },
      {
        id: View.KPI,
        subSection: KPITableView.Buy, // Default view for Retail Order
        name: {
          key: 'common.views.KPIView',
          default: 'KPI View'
        },
        icon: EnhancedViewIconMapping[View.KPI]
      }
      // {
      //   id: View.KPI,
      //   subSection: KPITableView.Buy,
      //   name: {
      //     key: 'common.views.KPIViewBuy',
      //     default: 'KPI View - Buy'
      //   },
      //   icon: EnhancedViewIconMapping[View.KPI]
      // },
      // {
      //   id: View.KPI,
      //   subSection: KPITableView.Forecast,
      //   name: {
      //     key: 'common.views.KPIViewForecast',
      //     default: 'KPI View - Forecast'
      //   },
      //   icon: EnhancedViewIconMapping[View.KPI]
      // }
    ]
  } else {
    if (orderType === OrderType.Door) {
      return [
        {
          id: View.Product,
          name: {
            key: 'common.views.cardView',
            default: 'Card View'
          },
          icon: EnhancedViewIconMapping[View.Product]
        },
        {
          id: View.List,
          name: {
            key: 'common.views.listView',
            default: 'List View'
          },
          icon: EnhancedViewIconMapping[View.List]
        },
        {
          id: View.KPI,
          subSection: KPITableView.Overview, // Default view for Door Order
          name: {
            key: 'common.views.KPIView',
            default: 'KPI View'
          },
          icon: EnhancedViewIconMapping[View.KPI]
        }
      ]
    } else {
      return [
        {
          id: View.Product,
          name: {
            key: 'common.views.cardView',
            default: 'Card View'
          },
          icon: EnhancedViewIconMapping[View.Product]
        },
        {
          id: View.List,
          name: {
            key: 'common.views.listView',
            default: 'List View'
          },
          icon: EnhancedViewIconMapping[View.List]
        },
        {
          id: View.KPI,
          subSection: KPITableView.Overview, // Default view for Order
          name: {
            key: 'common.views.KPIView',
            default: 'KPI View'
          },
          icon: EnhancedViewIconMapping[View.KPI]
        }
        // {
        //   id: View.KPI,
        //   subSection: KPITableView.Overview,
        //   name: {
        //     key: 'common.views.KPIViewOverView',
        //     default: 'KPI View - OverView'
        //   },
        //   icon: EnhancedViewIconMapping[View.KPI]
        // },
        // {
        //   id: View.KPI,
        //   subSection: KPITableView.DoorsKPI,
        //   name: {
        //     key: 'common.views.KPIViewDoorsKPI',
        //     default: 'KPI View - DoorsKPI'
        //   },
        //   icon: EnhancedViewIconMapping[View.KPI]
        // }
      ]
    }
  }
}

export const getEnhancedKPITabs = (clientType, orderType, customViewList) => {
  let tabList = []
  if (clientType === getEnumValue(VIPClientType.Internal)) {
    tabList = [
      { id: KPITableView.Buy, key: KPITableView.Buy, name: KPITableView.Buy },
      {
        id: KPITableView.Forecast,
        key: KPITableView.Forecast,
        name: KPITableView.Forecast
      }
    ]
  } else {
    tabList =
      orderType === OrderType.Door
        ? [
            {
              id: KPITableView.Overview,
              key: KPITableView.Overview,
              name: KPITableView.Overview
            }
          ]
        : [
            {
              id: KPITableView.Overview,
              key: KPITableView.Overview,
              name: KPITableView.Overview
            },
            {
              id: KPITableView.DoorsKPI,
              key: KPITableView.DoorsKPI,
              name: KPITableView.DoorsKPI
            }
          ]
  }
  if (customViewList?.length) {
    tabList = tabList.concat(
      customViewList.map(el => {
        return {
          id: el.id,
          key: el.id,
          name: el.name,
          isCustomView: true,
          isDeletable: true
        }
      })
    )
  }
  return tabList
}
